import { BreadcrumbJsonLd } from 'next-seo';
import { useMemo } from 'react';
import { normalizeAbsoluteHref } from 'src/utils/getHref';
import { Breadcrumb, BreadcrumbProps } from './Breadcrumb';
import * as S from './styles';

export type BreadcrumbsProps = {
  breadcrumbs: BreadcrumbProps['breadcrumb'][];
  inverse?: boolean;
};

export const Breadcrumbs = ({ breadcrumbs, inverse = false, ...rest }: BreadcrumbsProps) => {
  const jsonLdBreadcrumbs = useMemo(() => {
    return breadcrumbs.map(({ name, url: item }) => ({
      name,
      /* add default (production) host to breadcrumbs schema since it is only necessary for production */
      item: normalizeAbsoluteHref(item.toString(), undefined),
    }));
  }, [breadcrumbs]);

  return (
    <>
      <BreadcrumbJsonLd items={jsonLdBreadcrumbs} />

      <S.Breadcrumbs {...rest} data-testid="breadcrumbs" $inverse={inverse}>
        {breadcrumbs.map((breadcrumb, index) => (
          <Breadcrumb
            breadcrumb={breadcrumb}
            current={breadcrumbs.length === index + 1}
            key={breadcrumb.name}
          />
        ))}
      </S.Breadcrumbs>
    </>
  );
};
